const ErrorScreen = ({
  title = "Error Loading Application",
  message = "Something went wrong. Please try again later.",
  actionLabel = "Retry",
  onAction,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f9fafb",
        color: "#333",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2 style={{ color: "#d32f2f", marginBottom: "10px" }}>{title}</h2>
      <p style={{ maxWidth: "500px", marginBottom: "20px", fontSize: "16px" }}>
        {message}
      </p>
      {actionLabel && onAction && (
        <button
          style={{
            padding: "10px 20px",
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onClick={onAction}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default ErrorScreen;
